function EndMessage() {
  return (
    <>
      <div>
        <h2>¡Gracias por completar tu pre-registro!</h2>

        <p>
          Hemos recibido tu información. Nos pondremos en contacto contigo a
          través del correo proporcionado para cualquier comunicación adicional.
        </p>
      </div>
    </>
  );
}

export default EndMessage;
